import { getIndex } from '@apia/util';
import { constants } from './labels/constants-en';
import { constantsES } from './labels/constants-es';
import { constantsPT } from './labels/constants-pt';

const lang = window.LANG_CODE;

export const objects = getIndex(
  [constantsES, constantsPT, constants],
  [lang === 'es', lang === 'pt', true],
) as Readonly<typeof constants>;

export type TLabel = 'activitiesPrototype';
